import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { localVerticalHead } from "@/config/seoLocal";
import { redirectLegacyMunicipality } from "@/lib/legacyRedirects";
import { assertServiceSlug } from "@/lib/slugGuards";

const ServiceSlugPage = lazy(() => import("@/pages/produkter/ServiceSlugPage"));

export const Route = createFileRoute("/laddstolpar/$slug")({
  beforeLoad: ({ params }) => {
    redirectLegacyMunicipality("laddstolpar", params.slug);
  },
  // Kommun eller produkt – annars riktig 404.
  loader: ({ params }) => assertServiceSlug("laddstolpar", params.slug, { municipalityPages: true }),
  head: ({ params }) => localVerticalHead("laddstolpar", params.slug),
  component: () => <ServiceSlugPage vertical="laddstolpar" />,
});
